// extracted by css-extract-rspack-plugin
export default {"container":"DashboardAlertsPlaceholder_container__TlZ25"};